module.exports = __webpack_public_path__ + "images/generic-business-logo@2x-c80701c831f7ab01deb379f6851da788.png";